import "./RotateScreen.css";

function RotateScreen() {
  return (
    <div className="rotate-screen-container">
      <div className="phone"></div>
      <p className="message">אנא סובבו את הפלאפון</p>
    </div>
  );
}

export default RotateScreen;
